import React from "react";
import {Button, Modal} from "react-bootstrap";

class ErrorMessage extends React.Component{
    constructor(props) {
        super(props);
    }

    render(){
        return(
            <Modal show={true} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{this.props.text}</Modal.Body>
                <Modal.Footer>
                    {this.props.buttons.map((button, mkey) => {
                        return(
                            <Button variant="secondary" onClick={button.callback} key={mkey}>
                                {button.title}
                            </Button>
                        );
                    })}
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ErrorMessage;